import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule} from '@angular/router';
import { WholeNumberInputComponent } from './components/whole-number-input/whole-number-input.component';
import { NumericInputDirective } from './components/whole-number-input/numeric-input.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OnlineSchedulingConfirmComponent } from './components/online-scheduling/online-scheduling-confirm/online-scheduling-confirm.component';
import { PhoneInputComponent } from './components/phone-input/phone-input.component';
import { PhonePipe, PhoneListPipe } from './pipes/phone.pipe';
import { EmailInputComponent } from './components/email-input/email-input.component';
import { EmailPipe, EmailListPipe } from './pipes/email.pipe';
import { ImageEditorComponent } from './components/image-editor/image-editor.component';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';

@NgModule({
  	declarations: [WholeNumberInputComponent, NumericInputDirective, OnlineSchedulingConfirmComponent, PhoneInputComponent, PhonePipe, PhoneListPipe, EmailInputComponent, EmailPipe, EmailListPipe, ImageEditorComponent, BreadcrumbsComponent],
  	exports: [WholeNumberInputComponent, NumericInputDirective, PhoneInputComponent, PhonePipe, PhoneListPipe, EmailInputComponent, EmailPipe, EmailListPipe, ImageEditorComponent, BreadcrumbsComponent],
  	imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule],
   	entryComponents: [OnlineSchedulingConfirmComponent, ImageEditorComponent]
})
export class SharedModule {}